import { createTypes } from "../../../utils/redux/create-types";

export default createTypes(
    `
    UPDATE_PINCODE_SELECTION
    UPDATE_IS_SUBMITTED
    UPDATE_DEALER_NAME
`,
    {
        prefix: "becomeourpartnerinfo/"
    }
);
